import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
export function RouteLoadingFallback() {
    return (_jsxs("div", { className: "loading-container", children: [_jsx("div", { className: "loading-spinner" }), _jsx("p", { children: "Loading\u2026" })] }));
}
function buildReturnPath(location) {
    return `${location.pathname}${location.search}${location.hash}`;
}
export function ProtectedRoute({ children }) {
    const { isAuthenticated, isLoading, needsEmailVerification } = useAuth();
    const location = useLocation();
    if (isLoading) {
        return _jsx(RouteLoadingFallback, {});
    }
    if (!isAuthenticated) {
        return (_jsx(Navigate, { to: "/auth/login", replace: true, state: { from: buildReturnPath(location) } }));
    }
    if (needsEmailVerification) {
        return (_jsx(Navigate, { to: "/auth/verify-email", replace: true, state: { from: buildReturnPath(location) } }));
    }
    return _jsx(_Fragment, { children: children });
}
export function PublicOnlyRoute({ children }) {
    const { isAuthenticated, isLoading, needsEmailVerification } = useAuth();
    if (isLoading) {
        return _jsx(RouteLoadingFallback, {});
    }
    if (isAuthenticated) {
        return _jsx(Navigate, { to: needsEmailVerification ? '/auth/verify-email' : '/', replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
